import { API_ENDPOINT } from 'src/config/env.config';
import { BaseAPIResponse, GetAllSlotsAPIResponse, UserAvailabilityInput, GetRoundAvailabilityInput } from 'types';
import { baseApi } from './axios';

const baseUrl = `${API_ENDPOINT}/availability`;
export const updateSlots = async (payload: {
	id: string;
	slots: (UserAvailabilityInput & { _id?: string })[];
}): Promise<BaseAPIResponse> => {
	const response = await baseApi.patch(`${baseUrl}/${payload.id}`, { slots: payload.slots });
	return response.data;
};
export const getAllSlots = async (id: string): Promise<GetAllSlotsAPIResponse> => {
	const response = await baseApi.get(`${baseUrl}/${id}`);
	return response.data;
};
export const getRoundAvailability = async (payload: GetRoundAvailabilityInput): Promise<GetAllSlotsAPIResponse> => {
	const response = await baseApi.get(`${baseUrl}/round`, {
		params: payload,
	});
	return response.data;
};
export const getRoundTemplateAvailability = async (
	payload: GetRoundAvailabilityInput,
): Promise<GetAllSlotsAPIResponse> => {
	const response = await baseApi.get(`${baseUrl}/round-template`, {
		params: payload,
	});
	return response.data;
};
